import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { API } from "@/lib/api";

// Owner-managed Meta Pixel: the pixel ID is stored server-side (admin → Tracking)
// and only the ID is exposed publicly; we inject Meta's official snippet ourselves.
let pixelReady = false;

export const trackPixelEvent = (name, data = {}) => {
  if (pixelReady && typeof window.fbq === "function") {
    window.fbq("track", name, data);
  }
};

const loadPixel = async () => {
  if (pixelReady) return;
  try {
    const res = await fetch(`${API}/tracking`);
    const { pixel_id } = await res.json();
    if (!pixel_id) return;
    if (!window.fbq) {
      const fbq = function () {
        fbq.queue.push(arguments);
      };
      fbq.queue = [];
      fbq.loaded = true;
      fbq.version = "2.0";
      window.fbq = fbq;
      window._fbq = fbq;
      const s = document.createElement("script");
      s.async = true;
      s.src = "https://connect.facebook.net/en_US/fbevents.js";
      document.head.appendChild(s);
    }
    window.fbq("init", pixel_id);
    window.fbq("track", "PageView");
    pixelReady = true;
  } catch {
    /* tracking is best-effort and must never break the storefront */
  }
};

const MetaPixel = () => {
  const location = useLocation();
  const lastPath = useRef(location.pathname);

  useEffect(() => {
    loadPixel();
  }, []);

  // SPA route changes count as page views once the pixel is live
  useEffect(() => {
    if (lastPath.current !== location.pathname) {
      lastPath.current = location.pathname;
      trackPixelEvent("PageView");
    }
  }, [location.pathname]);

  return null;
};

export default MetaPixel;
